import { useQuery, useQueryClient } from 'react-query';

import { SOURCE_API_ROUTES } from '@/api-routes';
import { axiosInstance } from '@/axios';
import type { FetchRssSource as Source } from '@/types';

import { QUERY_KEY_ALL } from './useFetchAllWebsites';

type ResponseType = {
  results?: Source[];
};

export const QUERY_KEY = 'website';

const fetchRssPriority = async (sourceId: string, signal?: AbortSignal) => {
  return await axiosInstance.get<ResponseType>(
    `${SOURCE_API_ROUTES.rss()}?${new URLSearchParams([
      ['sourceIds', sourceId],
    ])}`,
    { signal }
  );
};

export const useFetchWebsite = (sourceId: string) => {
  const { isLoading, isError, data } = useQuery(
    [QUERY_KEY, sourceId],
    async ({ signal }) => fetchRssPriority(sourceId, signal),
    {
      staleTime: Infinity,
      select: (data) => {
        return data?.data['results'];
      },
    }
  );
  return { isLoading, isError, sources: data };
};

export const useRefetchWebsite = () => {
  const queryClient = useQueryClient();

  return (source_id: string) => {
    queryClient.invalidateQueries([QUERY_KEY, source_id]);
    queryClient.invalidateQueries([QUERY_KEY_ALL]);
  };
};
